import { useEffect, useState } from 'react';
import { collection, query, where, orderBy, getDocs } from 'firebase/firestore';
import { db } from '../firebase/config';
import { useAuth } from '../contexts/AuthContext';

export function useDriverOrderHistory() {
  const { currentUser } = useAuth();
  const [history,   setHistory]   = useState([]);
  const [cancelled, setCancelled] = useState([]);
  const [loading,   setLoading]   = useState(true);
  const [error,     setError]     = useState(null);

  useEffect(() => {
    if (!currentUser) return;

    async function fetch() {
      const [completedSnap, cancelledSnap] = await Promise.all([
        getDocs(query(
          collection(db, 'orders'),
          where('driverUid', '==', currentUser.uid),
          // Et fullført oppdrag blir 'invoiced' så snart fakturaen er laget, så begge regnes som fullført
          where('status', 'in', ['completed', 'invoiced']),
          orderBy('deliveredAt', 'desc'),
        )),
        getDocs(query(
          collection(db, 'orders'),
          where('driverUid', '==', currentUser.uid),
          where('status', '==', 'cancelled'),
        )),
      ]);

      setHistory(completedSnap.docs.map(d => ({ id: d.id, ...d.data() })));
      setCancelled(cancelledSnap.docs.map(d => ({ id: d.id, ...d.data() })));
      setLoading(false);
    }

    fetch().catch((err) => {
      console.error('useDriverOrderHistory:', err);
      setError(err);
      setLoading(false);
    });
  }, [currentUser]);

  return { history, cancelled, loading, error };
}
